module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid"
  }, _vm._l((_vm.tiles), function(tile) {
    return _c(tile.type, {
      tag: "div",
      staticClass: "grid__tile",
      attrs: {
        "data": tile.data
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0f56292c!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/layout/grid/Grid.vue
// module id = 707
// module chunks = 1